// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + (chunkId === 489 ? "EmojiMartPicker" : chunkId) + "-" + chunkId + "-" + {"388":"5ebed5d8494f926d4ff1","489":"1e1aaca182924217715c"}[chunkId] + ".js";
};